<div mat-dialog-title class="ds">
  <span>{{ appStrings.label_consignedWarehouse }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
@if (isLoading) {
  <div class="loading center">
    <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}
@if (showConfirmationOverlay) {
  <div class="overlay-container overlay flex-container" id="consigned-confirmation">
    <span class="whitespace"></span>
    <typography class="confirmation-text" variant="mat-body-1" weight="medium" id="question-container">
      {{ appStrings.label_consignedWhChangeQuestion }} {{ appStrings.label_areYouSure }}
    </typography>
    <span class="flex-container button-container">
      <span class="whitespace"></span>
      <ds-button id="question-no" size="medium" [label]="appStrings.button_cancel" type="secondary" variant="label-only"
        (click)="warehouseSwitchConfirmation(false)">
      </ds-button>
      <ds-button id="question-yes" size="medium" [label]="appStrings.button_confirm" type="primary" variant="label-only"
        (click)="warehouseSwitchConfirmation(true)">
      </ds-button>
      <span class="whitespace"></span>
    </span>
    <span class="whitespace"></span>
  </div>
}
@if (!isLoading) {
  <div id="formContainer" mat-dialog-content class="content ds">
    <form [formGroup]="warehouseForm">
      <div id="searchFormContent" class="warehouse-container">
        <ds-select id="warehouseList" class="fill-width no-subscript" [label]="appStrings.quote_selectInventory" [dropOptions]="warehouseList"
          label_orientation="vertical-label" [control]="warehouseForm.controls.selectedWarehouse" (selectionChange)="selectNewWarehouse()">
        </ds-select>
      </div>
    </form>

    <!-- desktop template -->
    <div *appIsDesktop>
      <div class="table-container" id="whGrid-container">
        <ds-table id="whGrid" mat-table matSort (matSortChange)="sortData($event)" [dataSource]="displayDataSource" [displayedColumns]="displayedColumns">
          <ng-container matColumnDef="lineNumber">
            <th mat-header-cell *matHeaderCellDef id="whGrid-lineNumber-label"> {{ appStrings.products_gridLineNumber }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-lineNumber-' + i">
              {{ (i+1)+currentPage*10 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="partNumber">
            <th mat-header-cell *matHeaderCellDef id="whGrid-partNumber-label"> {{ appStrings.products_gridPartNumber }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-partNumber-' + i">
              {{ element.partNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef id="whGrid-description-label"> {{ appStrings.products_gridDescription }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-description-' + i">
              {{ element.description }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastReceivedDate">
            <th mat-header-cell *matHeaderCellDef id="whGrid-lastReceivedDate-label"> {{ appStrings.products_gridLastReceivedDate }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-lastReceivedDate-' + i">
              {{ element.lastDateReceived | date:appInfoService.dateFormat }}
            </td>
          </ng-container>
          <ng-container matColumnDef="discontinued">
            <th mat-header-cell *matHeaderCellDef id="whGrid-discontinued-label"> {{ appStrings.products_gridDiscontinued }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-discontinued-' + i">
              {{ element.discontinued }}
            </td>
          </ng-container>
          <ng-container matColumnDef="availableQuantity">
            <th mat-header-cell *matHeaderCellDef id="whGrid-availableQuantity-label">
              {{ appStrings.label_quantityIn }}<br />
              {{ appStrings.label_warehouse }}
            </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-availableQuantity-' + i">
              {{ element.availableQuantity }}
            </td>
          </ng-container>
          <ng-container matColumnDef="addQuantity">
            <th mat-header-cell *matHeaderCellDef id="whGrid-addQuantity-label"> {{ appStrings.products_gridAddQuantity }} </th>
            <td mat-cell *matCellDef="let element;let i = dataIndex" [id]="'whGrid-addQuantity-' + i">
              <div class="quantity-selection-container">
                <input class="quantity-selection-input" [id]="'whGrid-addQuantityField-' + i"
                  [ngModel]="quantityMap.get(element) || 0" appDigitsOnly size="5" maxlength="5"
                  (ngModelChange)="changeInput($event,element)">
              </div>
            </td>
          </ng-container>
        </ds-table>
      </div>
      @if (totalPages > 1) {
        <div class="pagination-container">
          <div class="page-count" id="pageCount">
            <b>{{ pageOffset + 1 }} - {{ pageOffset + displayDataSource.length }}</b> {{appStrings.pagination_of}} <b>{{ recordList.length }}</b>
          </div>
          <div class="pagination" id="paginationWrapper">
            <ds-pagination
              id="pagination"
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>

    <!-- mobile template -->
    <div *appIsMobile class="mobile">
      @for (item of displayDataSource; track item; let i = $index) {
        <div class="card-container">
          <ds-paper class="dark-paper" elevation="elevation_none" borderRadius="radius_XS" outline="outlined"
            insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S" insidePaddingLeft="left-spacing_M" insidePaddingRight="right-spacing_S">
            <typography [id]="'description_label_'+i" variant="mat-body-1" weight="medium">
              #{{ (i+1)+currentPage*10 }} - {{ item.partNumber }}
            </typography>
            <div class="row">
              <div class="column">
                <typography [id]="'description_label_'+i" class="label" variant="mat-caption-1" weight="regular"> {{ appStrings.products_gridDescription }} </typography>
                <typography [id]="'description_'+i" variant="mat-body-2" weight="medium"> {{ item.description || '-' }} </typography>
              </div>
            </div>
            <div class="row">
              <div class="column one-third">
                <typography [id]="'lastReceivedDate_label_'+i" class="label" variant="mat-caption-1" weight="regular"> {{ appStrings.products_gridLastReceivedDate }} </typography>
                <typography [id]="'lastReceivedDate_'+i" variant="mat-body-2" weight="medium"> {{ item.lastDateReceived | date:appInfoService.dateFormat }} </typography>
              </div>
              <div class="column one-third">
                <typography [id]="'discontinued_label_'+i" class="label" variant="mat-caption-1" weight="regular"> {{ appStrings.products_gridDiscontinued }} </typography>
                <typography [id]="'discontinued_'+i" variant="mat-body-2" weight="medium"> {{ item.discontinued }} </typography>
              </div>
              <div class="column one-third">
                <typography [id]="'qtyInWarehouse_label_'+i" class="label" variant="mat-caption-1" weight="regular"> {{ appStrings.label_quantityInWarehouse }} </typography>
                <typography [id]="'qtyInWarehouse_'+i" variant="mat-body-2" weight="medium"> {{ item.availableQuantity }} </typography>
              </div>
            </div>
            <ds-divider></ds-divider>
            <div class="row">
              <div class="input-container">
                <typography [id]="'qtyInWarehouse_label_'+i" class="label" variant="mat-caption-1" weight="regular"> {{ appStrings.products_gridAddQuantity }} </typography>
                <input class="quantity-selection-input" [id]="'whGrid-addQuantityField-' + i"
                  [ngModel]="quantityMap.get(item) || 0" appDigitsOnly size="5" maxlength="5"
                  (ngModelChange)="changeInput($event,item)">
              </div>
            </div>
          </ds-paper>
        </div>
      }
      @if (totalPages > 1) {
        <div class="pagination-container">
          <div class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="small"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>
  </div>
}
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @if (quantityMap.size > 0) {
      <typography class="number-info" variant="mat-caption-1" weight="medium">{{ quantityMap.size }}&nbsp;{{ appStrings.label_partNumbersSelected }}
      </typography>
    }
    <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="handleClose(false)"
      [label]="appStrings.button_cancel">
    </ds-button>
    <ds-button id="addButton" variant="label-only" size="medium" type="primary" (onClick)="handleClose(true)"
      [label]="appStrings.button_addToQuote" [isDisabled]="quantityMap.size === 0">
    </ds-button>
  </div>
</div>
